/**
 * The application root: the query client and the browser router (SPEC §9.1).
 *
 * The route table itself lives in `routes/routes.ts` so tests can mount it in
 * a memory router.
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { createQueryClient } from './lib/queryClient'
import { routes } from './routes/routes'

const router = createBrowserRouter(routes)
const queryClient = createQueryClient()

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
